import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { NavLink } from 'reactstrap';
import { leftMenuTypes } from '../../constants';
import { Svg } from '../Svg';
export class MenuItem extends Component {
    static propTypes = {
        name: PropTypes.string,
        link: PropTypes.object,
        counter: PropTypes.object,
        menuItems: PropTypes.array,
        image: PropTypes.object,
        expandedLink: PropTypes.string,
        handlerSetExpandedLink: PropTypes.func
    };
    constructor(props) {
        super(props);
        this.state = {
            currentUrl: this.getCurrentUrl(),
            collapsed: false
        };
        this.toggleCollapsing = this.toggleCollapsing.bind(this);
        this.refresh = this.refresh.bind(this);
    }
    toggleCollapsing(e, value) {
        const { link, menuItems } = this.props;
        const { collapsed } = this.state;
        if (e) e.preventDefault();
        let collapsedValue = value !== undefined ? value : !collapsed;
        if (this.props.handlerSetExpandedLink && link.url && !collapsedValue) {
            this.props.handlerSetExpandedLink(link.url);
        }
        if (collapsedValue !== collapsed && menuItems?.length > 0) {
            this.setState({
                collapsed: collapsedValue
            });
        }
    }
    componentDidUpdate(prevProps) {
        const { link, menuItems, expandedLink } = this.props;
        if (prevProps.link !== link || prevProps.menuItems !== menuItems || prevProps.expandedLink !== expandedLink) {
            this.refresh();
        }
    }
    componentDidMount() {
        this.refresh();
    }
    refresh() {
        const { link, menuItems, expandedLink } = this.props;
        const { collapsed } = this.state;
        let isSelect = this.isSelected(link);
        if (menuItems) {
            for (let i = 0; i < menuItems.length; i++) {
                let item = menuItems[i];
                if (this.isSelected(item.link)) {
                    isSelect = true;
                }
            }
        }
        if ((expandedLink && expandedLink !== link?.url && !collapsed) || (!expandedLink && !isSelect)) {
            this.setState({
                collapsed: true
            });
        }
    }
    getCurrentUrl() {
        return window.location.pathname + (window.location.search ? window.location.search : "");
    }
    isSelected(link) {
        const curUrl = this.getCurrentUrl();
        let isSelected = curUrl === link?.url || curUrl === link?.url + '/';
        isSelected |= curUrl.startsWith(link?.url) && link?.url !== "/";
        return isSelected;
    }
    render() {
        const { link, image, counter, menuItems, isRoot, type } = this.props;
        let items = [];
        if (menuItems) {
            for (let i = 0; i < menuItems.length; i++) {
                let item = menuItems[i];
                if (!item.hiddenForMenu)
                    items.push(<MenuItem key={item.name ? item.name : i} link={item.link} type={item.type} collapsed={!item.expanded} name={item.name} image={item.image} counter={item.counter} />)
            }
        }
        let isSelected = this.isSelected(link);
        switch (type) {
            case leftMenuTypes.divider:
                return (
                    <li className={"menu-line"}></li>
                );
            case leftMenuTypes.link:
                return (
                    <li className={(isRoot ? "left-menu-item root-item " : "left-menu-item ") + (isSelected ? "selected " : "")}>
                        <div className="menu-item-link">
                            <NavLink className={isSelected ? "selected" : ""} tag={Link} to={link?.url ? link?.url : "/"}>
                                <span>{link?.text}</span>
                                {counter && !counter.hidden ? <span className={"left-menu-counter" + (isSelected ? " selected" : "")}>{counter?.count}</span> : ""}
                                {items.length > 0 ?
                                    //onClick={this.toggleCollapsing}
                                    <div className="collapse-menu-btn" >
                                        {/*<span className={(this.state.collapsed ? "collapsed-menu-icone" : "expanded-menu-icone") + (isSelected ? " selected" : "")} />*/}
                                        <span className="menu-btn-arr">
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path fillRule="evenodd" clipRule="evenodd" d="M11.2928 15.7071L6.29285 10.7071L7.70706 9.29285L12 13.5857L16.2928 9.29285L17.7071 10.7071L12.7071 15.7071C12.3165 16.0976 11.6834 16.0976 11.2928 15.7071Z" fill="black" fillOpacity="0.6" />
                                            </svg>
                                        </span>
                                    </div>
                                    : ""
                                }
                            </NavLink>
                        </div>
                        {image?.path && <Svg className="main-menu-icone" src={image?.path} />}
                        {
                            !(this.state.collapsed) ?
                                <ul className={items.length > 0 ? "with-padding" : ""}>
                                    {items.map(item =>
                                        item
                                    )}
                                </ul> : ""
                        }
                    </li>
                );
            default: return null;
        }
    }
}